
import {initWebComponent} from "@/helpers/web-component-helper";
import {setDrawGeometry, startDraw, stopDraw} from "@/helpers/ol/draw/ol-draw-polygon-helper";
import {createBox, createRegularPolygon} from "ol/interaction/Draw";
import {getFilterLayerName, getFilterVectorLayerStyle, removeFilterLayer} from "@/helpers/filter/filter-helper";
import {initLanguage, updateLanguage} from "@/modules/language/language";
import {geMeasureLayerName, geMeasureLayerStyle} from "@/helpers/tools/tools-measure-helper";
import {getPrintVectorLayerStyle} from "@/helpers/print/print-scales-helper";
import {
    getMutationLayerName,
    mutationGeometryFromGeometry,
    mutationGeometryFromMap
} from "@/helpers/tools/tools-mutation-helper";
import {generateSingleStyle, getWfsStyle} from "@/helpers/ol/wfs/wfs-style-helper";
import Swal from 'sweetalert2'
import {setBufferGeometry} from "@/helpers/measure/measure-buffer-helper";
import {
    getAllBySelector,
    getBySelector,
    hideElementsBySelector,
    showElementsBySelector
} from "@/helpers/element-helper";
import {filterGeometryFromMap} from "@/helpers/filter/filter-geometry-helper";
import {updateToolsMutationSelectLayer} from "@/helpers/tools/tools-mutation-select-layer-helper";
import toastr from "toastr";
import {getDefaultStyleFunction} from "@/helpers/ol/ol-style-helper.js";

export class OlDrawGeometryComponent extends HTMLElement {
    constructor(){
        super();

        const icon = this.getAttribute('data-icon')
        const language = this.getAttribute('data-language')
        const drawType = this.getAttribute('data-draw-type')
        const bookmarkPresentationID = this.getAttribute('data-bookmark-presentation-id')
        let languageType = language.charAt(0).toUpperCase() + language.slice(1)

        let checked = ''
        if(languageType === 'View') {
            checked = 'checked="checked"'
        }

        const template = document.createElement('template');
        template.innerHTML = `
    <label class="switcher mr-1 w-100">
        <input type="checkbox" value="` + languageType + `" class="switcher-input switchers-stacked-radio" name="switchers-stacked-radio" ` + checked + `>
        <span class="switcher-indicator">
          <span class="switcher-yes">
            <span class="fa fa-draw-polygon"></span>
          </span>
          <span class="switcher-no">
            <span class="fa fa-times"></span>
          </span>
        </span>
        
        <div class="switcher-label popper-header">
              <span class="${icon}"></span> <layout-language data-key="${language}"></layout-language>
               <div class="popper-tooltip" role="tooltip" data-popper-placement="right">
                <layout-language data-key="draw${languageType}"></layout-language>
                <div class="arrow" data-popper-arrow=""></div>
              </div>
            </div>
      </label>
`;

        // <span className="switcher-label w-100">
        //     <span className="` + icon + `"></span>
        //     <layout-language data-key="` + language + `"></layout-language>
        //     <small className="float-right"></small>
        // </span>

        initWebComponent(this, template)

        this.addEventListener('change', (evt) => {

            stopDraw()
            getAllBySelector('.switchers-stacked-radio').forEach(element => {
                if(evt.target.value !== element.value) {
                    element.checked = false
                }
            })

            if (!evt.target.checked || languageType === 'View') {

                hideElementsBySelector('#divToolsMeasureDrawButtons')

                if(window.drawMeasureVectorSource && window.drawMeasureVectorSource.getFeatures().length === 0) {
                    hideElementsBySelector('#divToolsMeasureToggleButtons')
                }
                return
            }

            let drawName
            let style
            let isClearDraw = false
            switch (drawType) {
                // Fileren
                case 'filter':
                    drawName = getFilterLayerName()
                    isClearDraw = true
                    style = getFilterVectorLayerStyle()

                    showElementsBySelector('#divPrintFilterCounter')
                    break;
                // Meten
                case 'measure':
                    drawName = geMeasureLayerName()
                    style = geMeasureLayerStyle()

                    if(languageType === 'Text') {
                        hideElementsBySelector('#divDrawFigure')
                        showElementsBySelector('#divDrawText')
                    } else {
                        hideElementsBySelector('#divDrawText')
                        showElementsBySelector('#divDrawFigure')
                    }

                    if(languageType === 'LineString' || languageType === 'Polygon') {
                        showElementsBySelector('#divToolsMeasureDrawButtons')
                    }

                    showElementsBySelector('#divToolsMeasureToggleButtons')

                    showElementsBySelector('layer-info-tools .btnHideInfoMenu')
                    break;
                // Tekenen
                case 'draw':
                    break;
                // Muteren
                case 'mutation':
                    drawName = getMutationLayerName()
                    style = window.wfsStyle.find(wfsStyle => parseInt(wfsStyle.id) === parseInt(bookmarkPresentationID))

                    if(style) {
                        if (Array.isArray(style.styles.styles)) {
                            style = generateSingleStyle(style.styles.styles[0].style_settings, undefined, true)
                        } else {
                            style = generateSingleStyle(style.styles.styles, undefined, true)
                        }
                    } else {
                        style = getDefaultStyleFunction()
                    }

                    getBySelector('#slcMutationSelectLayer').value = ''
                    hideElementsBySelector('#divMutationSelectLayer')
                    updateToolsMutationSelectLayer()
                    break;
            }

            const clickElement = this.querySelector('input')
            // clickElement.classList.toggle('active')
            removeFilterLayer()
            let geometryFunction = undefined

            // console.log(languageType)

            let geometryType = languageType
            switch (languageType) {
                case 'FromMap':
                    // console.log(drawType)
                    if(drawType === 'filter') {
                        filterGeometryFromMap()
                    } else {
                        mutationGeometryFromMap()
                    }
                    // setBufferGeometry()
                    return
                case 'Rectangle':
                    geometryType = 'Circle'
                    geometryFunction = createBox()
                    break;
                case 'Square':
                    geometryType = 'Circle'
                    geometryFunction = createRegularPolygon(4)
                    break;
                case 'Text':
                    Swal.fire({
                        title: 'Vul hier uw tekst in',
                        input: 'text',
                        inputAttributes: {
                            autocapitalize: 'off'
                        },
                        customClass: {
                            confirmButton: 'btn btn-success',
                            cancelButton: 'btn btn-outline-secondary'
                        },
                        confirmButtonText: 'Tekst plaatsen',
                        cancelButtonText: "Annuleren",
                        showCancelButton: true,
                    }).then((result) => {
                        if (result.value) {
                            startDraw(drawName, 'Point', geometryFunction, clickElement, isClearDraw, style, result.value)
                        }
                    })
                    return
                default:
                    if(drawType === 'mutation') {
                        mutationGeometryFromGeometry()
                    }
                    break;
            }

            startDraw(drawName, geometryType, geometryFunction, clickElement, isClearDraw, style)

        });

        updateLanguage()
    }
}

